import { render, staticRenderFns } from "./HelpDesk.vue?vue&type=template&id=d88874b8&scoped=true&"
import script from "./HelpDesk.vue?vue&type=script&lang=ts&"
export * from "./HelpDesk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88874b8",
  null
  
)

export default component.exports